import cx from 'classnames';
import _ from 'lodash';
import { Component, ReactElement } from 'react';
import { StreamPreview } from '../../../../../../../shared/frontend/components/presentational/streamPreview';

export const XX_LARGE_SIZE = { width: 480, height: 270 };
export const X_LARGE_SIZE = { width: 452, height: 254 };
export const LARGE_SIZE = { width: 356, height: 200 };
export const MEDIUM_SIZE = { width: 320, height: 180 };
export const SMALL_SIZE = { width: 249, height: 140 };
export const X_SMALL_SIZE = { width: Math.round(93 * (16 / 9)), height: 93 };

type TStatelessInteractiveStreamPreviewProps = {
  className?: string;
  thumbnailUrl: string;
  width: number;
  height: number;
  thumbnailWidth: number;
  thumbnailHeight: number;
  viewerCount?: number;
  streamIdentifier: string;
  isFeatured: boolean;
  featuredTitle?: string | ReactElement;
  streamerTitle?: string | ReactElement;
  live: boolean;
  type: 'twitch' | 'douyu';
  autoplay?: boolean;
  onClick?: Function;
  makeLiveImmediately?: boolean;
  style?: any;
  featuredTitleStyle?: any;
};

export class StatelessInteractiveStreamPreview extends Component<TStatelessInteractiveStreamPreviewProps> {
  public render() {
    return (
      <div className={cx(this.props.className, 'd-inline-block')} style={this.props.style}>
        <span className="rio-text--shadow">{(this.props.live || this.props.isFeatured) && this.getFeaturedTitle()}</span>
        <StreamPreview
          {...(_.omit(this.props, 'className') as any)}
          live={this.props.live}
          makeLiveImmediately={this.props.makeLiveImmediately}
          autoplay={this.props.autoplay}
          onClickThumbnail={this.props.onClick}
        />
        {this.props.live && this.props.streamerTitle && <div className="slds-m-top--x-small rio-text--shadow">{this.props.streamerTitle}</div>}
      </div>
    );
  }

  private getFeaturedTitle() {
    if (this.props.width <= SMALL_SIZE.width && this.props.height <= SMALL_SIZE.height) {
      return null;
    }
    const title = this.props.featuredTitle;
    if (!title) {
      return null;
    }
    return (
      <div
        className="slds-m-bottom--x-small slds-text-heading--small text-raiderio"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: 'bold',
          maxWidth: this.props.width,
          width: '100%',
          ...this.props.featuredTitleStyle
        }}
      >
        {title}
      </div>
    );
  }
}

type TInteractiveStreamPreviewProps = TStatelessInteractiveStreamPreviewProps;
type TInteractiveStreamPreviewState = Pick<TStatelessInteractiveStreamPreviewProps, 'live' | 'makeLiveImmediately'>;
export class InteractiveStreamPreview extends Component<
  TInteractiveStreamPreviewProps,
  TInteractiveStreamPreviewState
> {
  constructor(props: any, context?: any) {
    super(props, context);
    this.state = {
      live: props.live,
      makeLiveImmediately: props.makeLiveImmediately || false
    };
  }

  public render() {
    return (
      <StatelessInteractiveStreamPreview
        {...this.props}
        {...this.state}
        onClick={() => (this.props.onClick ? this.props.onClick() : this.makeLive())}
      />
    );
  }

  private makeLive = () => {
    this.setState({
      live: true,
      makeLiveImmediately: true
    });
  };
}
